import React, { useState } from 'react';
import { Provider as GameProvider } from '../context/game.context';

export default function GameService(props) {
  const [game, setGame] = useState(null);

  return (
    <GameProvider value={{ game, setGame }}>
      {props.children}
    </GameProvider>
  );
}